import { APIClient as n } from "./index.es453.js";
const o = {
  production: {
    baseUrl: "https://analytics.placer.ai",
    apiGatewayUrl: "https://dashboard-gateway.placer.ai"
  },
  staging: {
    baseUrl: "https://staging-analytics.placer.team",
    apiGatewayUrl: "https://staging-dashboard-gateway.placer.team"
  },
  development: {
    baseUrl: "https://staging-analytics.placer.team",
    apiGatewayUrl: "https://staging-dashboard-gateway.placer.team"
  }
}, l = ({
  token: a,
  environment: e
}) => {
  const r = o[e], { baseUrl: i, apiGatewayUrl: t } = r, s = {
    guruAdminAPI: i,
    guruAPI: i,
    esetAPI: `${t}/eset`,
    mapDocumentAPI: `${t}/map-document/v1`,
    tradeAreaAPI: `${t}/trade-area`,
    feTelemetryAPI: `${t}/fe-telemetry`,
    staticTilesAPI: `${t}/static-tiles`,
    siteSelectionAPI: `${t}/site-selection`,
    mapStudioPortfolioMetadataAPI: `${t}/mapstudio-portfolio-metadata/v1`
  };
  return {
    apiClient: n({
      endpoints: s,
      token: a
    }),
    token: a,
    endpoints: s,
    environment: e
  };
};
export {
  l as getApiClient
};
//# sourceMappingURL=index.es267.js.map
